import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `equipment-type`);
        return response;
    } catch (e) { }
}

export async function add(newDetails: any) {
    try {
        const response = await apiPost('core', `equipment-type`, newDetails);
        return response;
    } catch (e) { }
}

export async function update(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `equipment-type/${id}`, newDetails);
        return response;
    } catch (e) { }
}

export async function removeEquipmentType(id: any) {
    try {

        return await apiDelete('core', `equipment-type/${id}`);
    } catch (e) { }
}